<template>
  <v-container class="offer-tab">
    <v-row justify="end" align-content="end">
      <v-col cols="4" class="text-right">
        <v-btn
          color="primary"
          elevation="0"
          outlined
          :disabled="offerCount === 0 || isTaskFinished"
          @click="() => {$refs.offerSignDialog.openDialog()}"
        >{{$t('book/issue:common.sign-offer')}}</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="edit"
          :iconTooltip="$t('buttons:edit')"
          :addBtnText="$t('buttons:add-specific', {specific: $t('book/issue:offerDocumentation')})"
          @clickedAddButton="createOffer"
          @clickedButton1="v => $refs.offerDocumentation.openDialog(v)"
          :dependsOnProperty3="'isSigned'"
          :dependsOnProperty2="'editable'"
          :dependsOnProperty="'editable'"
          icon2="delete"
          icon3="visibility"
          :iconTooltip3="$t('buttons:view')"
          :iconTooltip2="$t('buttons:delete')"
          :trueFalseDecorateFields="['signed']"
          @clickedButton2="openDeleteWindow"
          @clickedButton3="v => $refs.offerDocumentation.viewDialog(v)"
          @updateTableData="updateTable"
          :addBtn="!isOfferSigned && !isTaskFinished"
          sort-by="id"
          :sortDesc="true" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <OfferDocumentationDialog
          @closeDialog="updateData"
          :key="'offerDialog' + key"
          ref="offerDocumentation" />
      </v-col>
      <v-col>
        <OfferSignDialog
          :taskInfo="taskInfo"
          ref="offerSignDialog"
          :key="'offerSignKey' + key"
          read-only
          :is-signed="isOfferSigned"
          @updateTask="v => updateTask(v)" />
      </v-col>
      <v-col>
        <TwoButtonDialog
            ref="deleteButton"
            :btn-text="$t('buttons:delete')"
            color="red"
            :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/issue:offerDocumentation')})"
            :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/issue:offerDocumentation')})"
            :button1-text="$t('buttons:cancel')"
            :button2-text="$t('buttons:delete')"
            @clickedButton1="$refs.deleteButton.showDialog = false"
            @clickedButton2="deleteOffer"
            hide-button
            hide-overlay
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import OfferDocumentationService from '@/modules/book/services/task-documentation/offer-documentation-service';
import OfferDocumentationDialog from '@/modules/book/views/task/components/OfferDocumentationDialog.vue';
import OfferSignDialog from '@/modules/book/views/task/dialog-components/OfferSignDialog.vue';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog.vue';
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated.vue';
import TaskBoardService from '@/modules/book/services/task-board-service';
import OfferDocumentation from '@/modules/book/data/offer-documentation';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';

export default {
  name: 'OfferTab',
  components: {TwoButtonDialog, OfferSignDialog, OfferDocumentationDialog, DataTablePaginated},
  props: {
    taskInfo: {},
    facility: {},
    isTaskFinished: Boolean
  },
  data() {
    return {
      offerList: [],
      offerCount: 0,
      offerDocumentationService: OfferDocumentationService,
      offerToRemove: {},
      key: 0
    };
  },
  computed: {
    isOfferSigned() {
      return !!this.taskInfo && !!this.taskInfo.signedOffer;
    },
    headers() {
      let header = [
        { text: this.$t('book/issue:common.supplier'), value: 'supplier', default: true, sortable:false },
        { text: this.$t('common:price'), value: 'price', default: true, sortable:false },
        { text: this.$t('common:valid-from'), value: 'startDate', default: true, sortable:false },
        { text: this.$t('common:valid-until'), value: 'endDate', default: true, sortable:false },
        { text: this.$t('book/issue:common.signed'), value: 'signed', default: true, sortable:false },
        { text: "", value: "controls", sortable: false, align: 'end' }
      ];

      return header;
    }
  },
  watch: {
    taskInfo() {
      this.$refs.table.callTableUpdate();
      if (!!this.taskInfo && !!this.taskInfo.id) {
        this.loadOffers();
      }
    }
  },
  methods: {
    loadOffers() {
      OfferDocumentationService.loadByTaskId(
        this.taskInfo.id,
        (response) => {
          this.offerList = response.data;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/issue:offerDocumentation')}));
        }
      )
    },
    updateTable(options, search) {
      if (!this.taskInfo || !this.taskInfo.id) {
        this.$refs.table.fillTableData(null);
        return;
      }

      if (!search) search = '';

      OfferDocumentationService.readAllPaginatedByTaskIdFromAPI(
        this.taskInfo.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, OfferDocumentation);
            this.offerCount = response.data.content.length;
            for (let i = 0; i < response.data.content.length; i++) {
              response.data.content[i].isSigned = this.isOfferSigned;
              response.data.content[i].editable = !this.isOfferSigned;
            }
            this.$refs.table.fillTableData(response.data);
            this.key++;
          }
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/issue:offerDocumentation')}));
          this.$logger.error(error);
        }
      )
    },
    createOffer() {
      this.$refs.offerDocumentation.openCreationDialog(
          {
            documentType: DocumentType.OFFER_TASK,
            taskId: this.taskInfo.id,
            customerId: this.taskInfo.manager
          }
      );
    },
    deleteOffer() {
      if (!this.offerToRemove || !this.offerToRemove.id) return;

      OfferDocumentationService.removeOffer(
          this.offerToRemove.id,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success',
              {name: this.$t('book/issue:offerDocumentation')}));
          this.$refs.table.callTableUpdate();
          this.offerToRemove = {};
          this.$refs.deleteButton.showDialog = false;
          this.updateData();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure',
              {name: this.$t('book/issue:offerDocumentation')}));
          this.$refs.table.callTableUpdate();
          this.offerToRemove = {};
          this.$refs.deleteButton.showDialog = false;
        }
      );
    },
    updateTask(task) {
      TaskBoardService.createOrEditTask(task,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:update-success', {name: this.$t('common:task')}));
          this.updateData();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:update-failure', {name: this.$t('common:task')}));
        }
      )
    },
    openDeleteWindow(offer) {
      this.$refs.deleteButton.showDialog = true;
      this.offerToRemove = offer;
    },
    clearData() {
    },
    updateData() {
      this.$refs.table.callTableUpdate();
      this.key++;
      this.$emit('updateData');
    }
  }
}
</script>